webpackJsonp([174340286061159],{

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _Markdown = __webpack_require__(20);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _propTypes = __webpack_require__(6);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _indexModule = __webpack_require__(316);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  data: PropTypes.object.isRequired
	};
	
	var About = function (_React$Component) {
	  _inherits(About, _React$Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	    var content = this.props.data.page.edges[0].node;
	    return _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.main },
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          content.title
	        ),
	        _react2.default.createElement("meta", { name: "description", content: content.metaDescription }),
	        _react2.default.createElement("meta", { property: "og:title", content: content.title }),
	        _react2.default.createElement("meta", { property: "og:description", content: content.metaDescription })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.imageContainer },
	        content.image && _react2.default.createElement("img", {
	          className: _indexModule2.default.image,
	          src: content.image.file.url + "?w=300",
	          srcSet: "\n                  " + content.image.file.url + "?w=300 300w,\n                  " + content.image.file.url + "?w=410 410w,\n                  " + content.image.file.url + "?w=615 615w,\n                  " + content.image.file.url + "?w=820 820w\n                "
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.content },
	        content.title && _react2.default.createElement(
	          "h1",
	          { className: _indexModule2.default.title },
	          content.title
	        ),
	        content.intro && _react2.default.createElement(_Markdown2.default, { className: _indexModule2.default.intro, source: content.intro.intro }),
	        content.body && _react2.default.createElement(_Markdown2.default, { className: _indexModule2.default.body, source: content.body.body })
	      )
	    );
	  };
	
	  return About;
	}(_react2.default.Component);
	
	About.propTypes = propTypes;
	
	exports.default = About;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"src-pages-over----index-module---main---3bRFd src-global-styles----content---content---2NlNu src-global-styles----content---maxWidth---6eZ_6","imageContainer":"src-pages-over----index-module---imageContainer---2DqC_","image":"src-pages-over----index-module---image---2d2m2","content":"src-pages-over----index-module---content---2qAik","title":"src-pages-over----index-module---title---2cbZi","text":"src-pages-over----index-module---text---3ntT0","link":"src-pages-over----index-module---link---17mVz"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-over-index-js-f4c67c76fc27f855d7fb.js